import React from 'react';
import { Badge } from '../../core-ui';
import { RecipientStatus } from '../../runtypes/RecipientRuntype';

type StatusDescriptor = { getLabel: () => string; color: string };

const statusMap: Record<RecipientStatus, StatusDescriptor> = {
  SENT: {
    getLabel: () => t('Sent'),
    color: 'green',
  },
  PENDING: {
    getLabel: () => t('Pending'),
    color: 'yellow',
  },
  FAILED: {
    getLabel: () => t('Failed'),
    color: 'red',
  },
};

export function RecipientStatusBadge(props: { status: RecipientStatus }) {
  const { status } = props;
  const descriptor = statusMap[status];
  if (descriptor) {
    return (
      <Badge colorScheme={descriptor.color}>{descriptor.getLabel()}</Badge>
    );
  }
  return null;
}
